import { SLIDE_1_KICKER } from "./landingHeroCopy";
import {
  SAMPLE_QUESTION_CHOICES,
  SAMPLE_QUESTION_META,
  SAMPLE_QUESTION_STATEMENT,
} from "./sampleQuestion";
import "./LandingHeroModelCard.css";

export default function LandingHeroModelCard() {
  return (
    <div className="lh-card" aria-hidden="true">
      <p className="lh-card-kicker">{SLIDE_1_KICKER}</p>
      <p className="lh-card-meta">{SAMPLE_QUESTION_META}</p>
      <p className="lh-card-statement">{SAMPLE_QUESTION_STATEMENT}</p>
      <div className="lh-card-options">
        {SAMPLE_QUESTION_CHOICES.map((choice) => (
          <div key={choice.id} className="lh-card-option">
            <span className="lh-card-option-main">
              <span className="lh-card-letter">{choice.id.toUpperCase()}</span>
              <span className="lh-card-option-text">{choice.text}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
